import CardPage from '@/pages/example/Card.vue';

export const mfRoutes = [
  {
    path: '/sights/:slug',
    name: 'attractions-card',
    component: CardPage,
  },
];

export default mfRoutes;
